module.exports = __webpack_public_path__ + "static/media/Balenciaga-Black-Speed-Knit-Sneakers-Lyst_thumb.0e1908f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/Balenciaga-Black-Speed-Knit-Sneakers-Lyst_thumb.png
// module id = 294
// module chunks = 0